function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';
import PropTypes from 'prop-types';
import defaultPropTypes from '../../utils/prop-types';
import { renderComponents } from '../../utils/convenience';
import ListItem from './list-items/list-item';
import FilterList from '../filter-list';
var DISABLED_CLASS_NAME = 'disabled';
var INITIAL_PAGER_STATE = {
  currentPage: 0
};

var ListPager = function ListPager(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "pager"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pager-status"
  }, "Showing ", /*#__PURE__*/React.createElement("span", {
    className: "page-end"
  }, props.currentEnd), " out of", /*#__PURE__*/React.createElement("span", {
    className: "page-total"
  }, props.totalRecords), " Results"), /*#__PURE__*/React.createElement("div", {
    className: "pager-buttons"
  }, /*#__PURE__*/React.createElement("a", {
    // eslint-disable-line jsx-a11y/anchor-is-valid
    role: "button",
    className: "pager-append-next-button ".concat(props.disableNext),
    onClick: function onClick(e) {
      props.nextPageClick(props.currentPage, e);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.keyCode === 13) {
        props.nextPageClick(props.currentPage, e);
      }
    },
    disabled: props.disableNext === DISABLED_CLASS_NAME
  }, "Show More Results")));
};

var ListLoadMore = /*#__PURE__*/function (_React$Component) {
  _inherits(ListLoadMore, _React$Component);

  var _super = _createSuper(ListLoadMore);

  function ListLoadMore(props) {
    var _this;

    _classCallCheck(this, ListLoadMore);

    _this = _super.call(this, props);
    _this.props.settings.ListCount = 20;
    _this.handleNextPageClick = _this.handleNextPageClick.bind(_assertThisInitialized(_this));
    _this.state = INITIAL_PAGER_STATE;
    _this.state.locationsStateHash = _this.props.locationsStateHash;
    return _this;
  }

  _createClass(ListLoadMore, [{
    key: "setPagerState",
    value: function setPagerState(currentPage) {
      this.setState({
        currentPage: currentPage
      });
    }
  }, {
    key: "calculatePageState",
    value: function calculatePageState(currentPage) {
      var maxPages = Math.ceil(this.props.locations.length / this.props.settings.ListCount) - 1; // Page numbers start at 0

      var currentStartRecord = this.props.locations.length > 0 ? currentPage * this.props.settings.ListCount + 1 : 0;
      var currentEndRecord = Math.min((currentPage + 1) * this.props.settings.ListCount, this.props.locations.length);
      var disableNextButton = currentPage >= maxPages ? DISABLED_CLASS_NAME : '';
      return {
        currentStartRecord: currentStartRecord,
        currentEndRecord: currentEndRecord,
        disableNextButton: disableNextButton
      };
    }
  }, {
    key: "handleNextPageClick",
    value: function handleNextPageClick(page, e) {
      var numOfPages = Math.ceil(this.props.locations.length / this.props.settings.ListCount);

      if (page <= numOfPages) {
        var currentPage = page + 1;
        this.setPagerState(currentPage);
      }

      e.preventDefault();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var ItemView = this.props.listItemView;
      var startLocationIndex = this.props.settings.ListCount * this.state.currentPage;
      var truncatedLocations = this.props.locations.slice(0, this.props.settings.ListCount + startLocationIndex);
      var pageState = this.calculatePageState(this.state.currentPage);
      return /*#__PURE__*/React.createElement("div", {
        className: "locations-list ".concat(this.props.layoutType)
      }, this.props.filterListOpen && /*#__PURE__*/React.createElement(FilterList, this.props), !this.props.filterListOpen && /*#__PURE__*/React.createElement(React.Fragment, null, renderComponents('header', this.props.header, this.props), /*#__PURE__*/React.createElement("div", {
        className: "content"
      }, truncatedLocations.map(function (location, index) {
        return /*#__PURE__*/React.createElement(ItemView, Object.assign({
          key: "locationItem-".concat(location.UniqueId),
          location: location,
          index: index
        }, _this2.props));
      }), /*#__PURE__*/React.createElement(ListPager, _extends({
        nextPageClick: this.handleNextPageClick,
        currentStart: pageState.currentStartRecord,
        currentEnd: pageState.currentEndRecord,
        currentPage: this.state.currentPage,
        totalRecords: this.props.locations.length,
        disableNext: pageState.disableNextButton
      }, this.props))), renderComponents('footer', this.props.footer, this.props)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, theState) {
      if (nextProps.locationsStateHash !== theState.locationsStateHash) {
        var newState = INITIAL_PAGER_STATE;
        newState.locationsStateHash = nextProps.locationsStateHash;
        return newState;
      }

      return null;
    }
  }]);

  return ListLoadMore;
}(React.Component);

export default ListLoadMore;
ListLoadMore.propTypes = {
  selectedLocation: defaultPropTypes.location,
  openLocation: defaultPropTypes.location,
  locations: defaultPropTypes.locations,
  onSelectLocation: defaultPropTypes.func,
  onOpenLocation: defaultPropTypes.func,
  onCloseFilterList: defaultPropTypes.func,
  onChangeFilter: defaultPropTypes.func,
  layoutType: defaultPropTypes.layoutType,
  settings: defaultPropTypes.settings,
  header: PropTypes.arrayOf(PropTypes.element),
  footer: PropTypes.arrayOf(PropTypes.element),
  listItemView: PropTypes.func,
  filterListOpen: PropTypes.bool,
  locationsStateChanged: PropTypes.string,
  locationsStateHash: PropTypes.string.isRequired
};
ListLoadMore.defaultProps = {
  selectedLocation: defaultPropTypes.defaultLocation(),
  openLocation: defaultPropTypes.defaultLocation(),
  locations: defaultPropTypes.defaultLocations,
  onSelectLocation: defaultPropTypes.defaultOnSelectLocation,
  onOpenLocation: defaultPropTypes.defaultOnOpenLocation,
  onCloseFilterList: defaultPropTypes.defaultOnCloseFilterList,
  onChangeFilter: defaultPropTypes.defaultOnChangeFilter,
  layoutType: defaultPropTypes.defaultLayoutType,
  settings: defaultPropTypes.defaultSettings,
  header: [],
  footer: [],
  listItemView: ListItem,
  filterListOpen: false,
  locationsStateChanged: ''
};
ListPager.propTypes = {
  currentEnd: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  nextPageClick: PropTypes.func.isRequired,
  totalRecords: PropTypes.number.isRequired,
  disableNext: PropTypes.string.isRequired
};